// UpdateCoords.js
import proj4 from "proj4"

const updateCoords = (e, model) => {
  let zone = Math.ceil((e.lngLat.lng+180)/6)
  let utmZone = zone.toString()
  // Define the source zone (x / y type)
  proj4.defs(`EPSG:326${utmZone}`, `+proj=utm +zone=${utmZone} +datum=WGS84 +units=m +no_defs`)
  let selectedProjection = 'swmmNode_proj'
  let selectedTransform  = 'swmmNode_t'
  let source = '+proj=longlat +datum=WGS84'

  let projection = model.PCS[selectedProjection]
  // The source data is usually in ft/m.
  // It needs to be translated to lat/lng*/
  let dest = '+proj='  + projection.proj  +
            ' +zone='  + projection.zone  +
            ' +datum=' + projection.datum +
            ' +units=' + projection.units +
            ' +defs='  + projection.defs              
  let tform  = model.TRANSFORM[selectedTransform]
  let transform = proj4(dest)

  // Get the x/y coords of the clicked point
  let coord = [e.lngLat.lng, e.lngLat.lat]

  let swmmCoord = proj4(source, dest, coord)
  swmmCoord[0] = transform.forward([e.lngLat.lng, e.lngLat.lat])[0]+model.MAP.DIMENSIONS.x1-tform.x
  swmmCoord[1] = transform.forward([e.lngLat.lng, e.lngLat.lat])[1]+model.MAP.DIMENSIONS.y1-tform.y

  return swmmCoord
}

const createFullLine = (e, model, upstreamNode, midLngLatsRef) => {
  let linestringCoords = [
    [model.COORDINATES[upstreamNode].x, model.COORDINATES[upstreamNode].y],
    ...midLngLatsRef,
    [model.COORDINATES[e.features[0].properties.name].x, model.COORDINATES[e.features[0].properties.name].y]
  ]

  return linestringCoords
}

const createVertices = (e, model, midLngLatsRef) => {
  let zone = Math.ceil((e.lngLat.lng+180)/6)
  let utmZone = zone.toString()
  // Define the source zone (x / y type)
  proj4.defs(`EPSG:326${utmZone}`, `+proj=utm +zone=${utmZone} +datum=WGS84 +units=m +no_defs`)
  let selectedProjection = 'swmmNode_proj'
  let selectedTransform  = 'swmmNode_t'

  let projection = model.PCS[selectedProjection]
  let dest = '+proj='  + projection.proj  +
            ' +zone='  + projection.zone  +
            ' +datum=' + projection.datum +
            ' +units=' + projection.units +
            ' +defs='  + projection.defs 
  let tform  = model.TRANSFORM[selectedTransform]
  let transform = proj4(dest)

  let newentry = midLngLatsRef.map(coords=>({
    "x": transform.forward(coords)[0]+model.MAP.DIMENSIONS.x1-tform.x,
    "y": transform.forward(coords)[1]+model.MAP.DIMENSIONS.y1-tform.y
  }))

  return newentry
}




export { updateCoords, createFullLine, createVertices }